export const API_ENDPOINTS = {
  LOGIN: '/api/login',
  LOGIN_VERIFY_OTP: '/api/login/verify-otp',
  REGISTER: '/api/register',
  ME: '/api/me',
  CHAT: '/api/chat',
  CHAT_STREAM: '/api/chat-stream',
  CONVERSATION_HISTORY: '/api/conversation-history',
  CONVERSATION_DELETE: '/api/conversation-delete',
  CHAT_SESSIONS: '/api/chat-sessions',
  CHAT_SESSION_STAR: (sessionId) => `/api/chat-sessions/${encodeURIComponent(sessionId)}/star`,
  OAUTH_AUTHORIZE: (provider) => `/api/oauth/${provider}/authorize`,
  OAUTH_CALLBACK: (provider) => `/api/oauth/${provider}/callback`,
  PASSWORD_RESET_REQUEST: '/api/password-reset-request',
  PASSWORD_RESET: '/api/password-reset',
  ADMIN_USERS: '/api/admin/users',
  ADMIN_USER_CONVERSATIONS: (userId) => `/api/admin/users/${userId}/conversations`,
  ADMIN_USER_STUDIES: (userId) => `/api/admin/users/${userId}/studies`,
  ADMIN_DELETE_USER_STUDY: (userId, studyId) => `/api/admin/users/${userId}/studies/${studyId}`,
  ADMIN_UPDATE_USER_ROLE: (userId) => `/api/admin/users/${userId}/role`,
  ADMIN_DELETE_USER: (userId) => `/api/admin/users/${userId}`,
  ADMIN_DELETE_USER_CONVERSATIONS: (userId) => `/api/admin/users/${userId}/conversations`,
  ADMIN_DELETE_USER_CHAT_SESSION: (userId, sessionId) => `/api/admin/users/${userId}/sessions/${encodeURIComponent(sessionId)}`,
  ADMIN_RESEARCHERS: '/api/admin/researchers',
  ADMIN_RESEARCHER_STUDIES: (researcherId) => `/api/admin/researchers/${researcherId}/studies`,
  ADMIN_STUDIES: '/api/admin/studies',
  ADMIN_STUDIES_COUNT: '/api/admin/studies/count',
  ADMIN_CREATE_STUDY: '/api/admin/studies',
  ADMIN_UPDATE_STUDY: (studyId) => `/api/admin/studies/${studyId}`,
  ADMIN_DELETE_STUDY: (studyId) => `/api/admin/studies/${studyId}`,
  ADMIN_STUDY_PATIENTS: (studyId) => `/api/admin/studies/${studyId}/patients`,
  ADMIN_CLINICAL_TRIALS_IMPORTED_STATUS: '/api/admin/clinical-trials/imported-status',
  ADMIN_PATIENT_SUMMARIES: '/api/admin/patient-summaries',
  ADMIN_PATIENT_SUMMARY: (summaryId) => `/api/admin/patient-summaries/${summaryId}`,
  ADMIN_NOTIFY_PATIENT_SUMMARY: (summaryId) => `/api/admin/patient-summaries/${summaryId}/notify`,
  PATIENT_SUMMARY_REVIEW_STATUS: (summaryId) => `/api/patient-summary/${summaryId}/review-status`
}

export const ROUTES = {
  HOME: '/',
  WELCOME: '/welcome',
  CHAT: '/chat',
  ADMIN: '/admin',
  PROFILE: '/profile',
  OAUTH_CALLBACK: '/auth/callback',
  RESET_PASSWORD: '/reset-password/:token',
  RESEARCHER_VERIFICATION: '/researcher/verification',
  RESEARCHER_LOGIN: '/researcher/login',
  RESEARCHER_DASHBOARD: '/researcher/dashboard',
  PATIENT_SUMMARY: '/patient-summary/:token',
  ADMIN_RESEARCHERS: '/admin/researchers',
  TERMS_OF_USE: '/terms-of-use',
  PRIVACY_POLICY: '/privacy-policy',
  ABOUT_US: '/about-us',
  BECOME_PARTNER: '/become-a-partner',
  FAQ: '/faq',
  HOW_IT_WORKS: '/how-it-works'
}

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'auth_token',
  USER: 'user',
  RESEARCHER_ID_TOKEN: 'researcher_id_token',
  RESEARCHER_REFRESH_TOKEN: 'researcher_refresh_token',
  RESEARCHER_ACCESS_TOKEN: 'researcher_access_token',
  CURRENT_RESEARCHER: 'current_researcher'
}

export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  NOT_FOUND: 404,
  SERVER_ERROR: 500
}

export const VALIDATION = {
  MIN_PASSWORD_LENGTH: 10,
  EMAIL_REGEX: /\S+@\S+\.\S+/,
  // Strong password: uppercase, lowercase, digit, special character.
  PASSWORD_UPPERCASE_REGEX: /[A-Z]/,
  PASSWORD_LOWERCASE_REGEX: /[a-z]/,
  PASSWORD_DIGIT_REGEX: /\d/,
  PASSWORD_SPECIAL_REGEX: /[!@#$%^&*()\-_=+[\]{};:'",.<>/?\\|`~]/,
  PASSWORD_REQUIREMENTS_MESSAGE:
    'Password must be at least 10 characters and include uppercase, lowercase, a digit, and a special character.'
}

// Consent attestation version. Must match backend CONSENT_VERSION in
// backend/app/core/consent.py — bump in lockstep when the attestation
// copy in RegisterModal.vue changes.
export const CONSENT_VERSION = '2026-05-06'

export const CONSENT_LINKS = {
  PRIVACY_POLICY: 'https://wesearchresearch.net/privacy-policy',
  TERMS_OF_USE: 'https://wesearchresearch.net/terms-of-use'
}

export const TIMEOUTS = {
  API_REQUEST: 120000,
  AUTH_INIT: 60000
}

export const ERROR_MESSAGES = {
  GENERIC_ERROR: 'An error occurred. Please try again.',
  CHAT_ERROR: 'I\'m feeling a bit under the weather... Can you please re-type your response?'
}

export const OAUTH_PROVIDERS = {
  GOOGLE: 'google',
  MICROSOFT: 'microsoft',
  FACEBOOK: 'facebook'
}

export const OAUTH_ENDPOINTS = {
  AUTHORIZE: '/api/oauth',
  CALLBACK: '/auth/callback'
}

// Participant summary review status options. These are defined in code (not a
// database enum) so they can be changed in future without a migration. The
// string values MUST match REVIEW_STATUS_OPTIONS in
// backend/app/models/patient_summary.py exactly.
export const REVIEW_STATUS_OPTIONS = [
  'Not yet contacted',
  'Contacted & Eligible',
  'Contacted & Not Eligible'
]

export const DEFAULT_REVIEW_STATUS = REVIEW_STATUS_OPTIONS[0]
